import {
  number,
  string,
  oneOfType,
  instanceOf
} from 'prop-types'

export default oneOfType([instanceOf(Date), number, string])